const Alert = {
  variants: {
    primary: {
      container: {
        color: "white",
        bg: "primary"
      }
    },
    secondary: {
      container: {
        color: "white",
        bg: "primaryDark"
      }
    },
  },
};

export default Alert;
